/**
 * Created by zzy on 2019/8/26.
 */
import ShowAlarmEvent from './ShowAlarmEvent.vue'
export default ShowAlarmEvent



// WEBPACK FOOTER //
// ./src/views/common/showAlarmEvent/index.js